<!--
|--------------------------------------------------
|      询价管理-拟定供应商对应零件弹窗
|
|
|
|--------------------------------------------------
-->
<template>
<el-dialog v-if="visible" title="选择中标供应商" width="80%" :visible.sync="visible" class="rfq-dialog" append-to-body @close="cancel()">
<div>
    <el-table :data="this.summaryList" border style="width: 100%" :header-cell-style="{background:'#f5f5f5'}" @selection-change="selectionChangeHandle" stripe size="mini">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="rfqSupplierName" label="供应商名称" header-align="center" align="left" />
        <el-table-column prop="rfqSupplierCode" label="供应商编码" header-align="center" align="left" />
        <el-table-column prop="rfqContractMail" label="供应商邮箱" header-align="center" align="right" />
        <!-- <el-table-column prop="targetPrice" label="目标价格" header-align="center" align="right" />
        <el-table-column prop="salePriceCost" label="含税总价" header-align="center" align="right">
            <template slot-scope="scope">
                {{fixedNumber(scope.row.salePriceCost)}}
            </template>
        </el-table-column> -->
        <el-table-column prop="rfqSupplyRadio" label="中标份额1(%)" header-align="center" align="left">
            <template slot-scope="scope">
                <ctl-number v-model="scope.row.rfqSupplyRadio" :min="0" :max="100"></ctl-number>
            </template>
        </el-table-column>

    </el-table>

    <!-- 分页 -->
    <!-- <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
    </el-pagination> -->

</div>
    <div slot="footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary" @click="confirm()">确认</el-button>
    </div>
</el-dialog>
</template>

<script>
// require('@/mock/mockRFQ');
import {
    DIALOG_CLOSED_TYPE,
    SUPPLY_STATUS,
    getLabelByValue,
} from "@/utils/const";
import {
    getRfqSupplierList
} from '@/controller/rfq'
import {
    getRfqPartPageList,
} from '@/controller/rfq'
import CtlNumber from '@/views/common/ctl-number'
export default {
    data() {
        return {
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            partList: [],
            summaryList: [],
            visible: false,
            dataListSelections: [],//多选的row
            row:'',
        };
    },
    components: {
        CtlNumber
    },
    mounted() {
    },
    methods: {
        init(row, rfqId,summaryList){
            this.visible = true
            this.row = row
            this.getRfqSupplierList(rfqId)
            // this.summaryList = summaryList
            // for(let key in this.summaryList){
            //     this.summaryList[key].rfqSupplyRadio = ''
            // }
            this.dataListSelections=[]
        },
        getRfqSupplierList(rfqId) {
            getRfqSupplierList({
                rfqId: rfqId,
            }).then((data) => {
                if (data && data.code === "00") {

                    const cleanList = data.body.filter(v =>{
                        return v.rfqSupplierReplyStatus === '4'
                    })
                    this.summaryList = cleanList
                } else {
                    this.summaryList = [];
                }
            })
        },
        fixedNumber(val) {
            if (!val) {
                return 0
            }
            return Number(Number(val).toFixed(3))
        },
        cancel(){
            this.$emit('close')
            this.visible = false
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        confirm() {
            var count = 0;
            for(let key in this.dataListSelections){
                count = count + Number(this.dataListSelections[key].rfqSupplyRadio)
            }
            if(count != 100){
               return  this.$message.error('中标份额不能大于100')
            }
            const params ={
                row:this.row,
                suppliers:this.dataListSelections
            }
            this.$emit('confirm', params)
            this.visible = false
        },
        // 查所有零件
        getPartList(row, rfqId) {
            getRfqPartPageList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                rfqId: rfqId,
            }).then((data) => {
                if (data && data.code === "00") {
                    if (data.body) {
                        this.partList = data.body.records
                        this.totalPage = data.body.total
                    } else {
                        this.partList = []
                        this.totalPage = 0
                    }
                } else {
                    this.partList = []
                    this.totalPage = 0
                }
            })
        },
    },
};
</script>

<style lang="scss">
.el-dialog__body {
    .org-dialog-form {
        width: 95%;
    }
}

.linetext {
    white-space: pre-line;
}

.mt20 {
    margin-top: 20px;
}
</style>
